import { CHAT_SHARE_SEGMENT } from "@/constants";

export const redirectToLogin = () => {
    const isLocal = window.location.hostname === "localhost";
    const iqUrl = location.origin + location.pathname;
    const saralUrlObj = new URL(isLocal ? "http://localhost:4200/auth" : import.meta.env.VITE_PRODUCT_SARAS);
    const usp = new URLSearchParams();
    usp.set('redirectTo', iqUrl);
    usp.set('productType', 'IQ');
    saralUrlObj.search = usp.toString();
    window.location.href = saralUrlObj.href;
}
export const hasSamePath = (path: string) => {
    return window.location.pathname === path;
}

export const getChatBasePath = () => 'chat';

/**
 * Whether `pathname` is inside the chat section (`/chat` or `/chat/<id>`).
 *
 * Deliberately segment-exact: a plain `startsWith('/chat')` also matches
 * `/chats` (the chat LIST route), which is exactly the case this guard exists to
 * exclude.
 */
export const isChatSectionPath = (pathname: string) => {
    const base = `/${getChatBasePath()}`;
    if (pathname.startsWith(`${base}/${CHAT_SHARE_SEGMENT}/`)) return false;
    return pathname === base || pathname.startsWith(`${base}/`);
};

/**
 * Whether clicking a chat nav item should (re)select its thread.
 *
 * openui's `selectThread` unconditionally resets `messages: []` as part of
 * selecting, so re-selecting the already-active thread wipes the visible
 * messages — and because the URL doesn't change on a same-thread click, nothing
 * repopulates them, leaving a blank chat view. Skip the selection when the
 * target is already active; still select when switching threads (incl. from no
 * active thread).
 */
export const shouldSelectChatThread = (
    selectedThreadId: string | null | undefined,
    targetId: string,
) => (selectedThreadId ?? '') !== targetId;
